// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "staticPC/js/" + chunkId + "." + {"189":"5ee6f5ad","205":"127a9043","224":"10312c72","327":"895da7eb","427":"685bbb40","506":"05a5eba2","531":"3063fa3a","579":"68d6180d","606":"3ec5efed"}[chunkId] + ".js";
};